<template lang="pug">
  v-card(
    class="pa-1",
    flat,
    style="background: none;",
  )
    h2.mb-1 {{dashboard.title}}
    h3 {{dashboard.description}}
    v-row
      v-col(v-for="chart in dCharts" :cols="chart.value")
        chart-component(:chart="chart")

</template>
<script>

export default {
  props: ['dashboard', 'chartsList'],
  data: function () {
    return {
      blankSpace: { name: "Blank space", id: -1},
      dCharts: []
    }
  },
  methods: {
    async getCharts(chartsConfig) {

      let charts = [];
      for (const [key, value] of Object.entries(chartsConfig)) {
        var chart = this.findChart(value.chartId);
        if (this.isBlankSpace(chart)) {
          charts.push({ id: chart.id, value: value.size, name: chart.name });
        } else {
          charts.push(await this.setField(chart, value.size));
        }
      }
      return charts;
    },

    findChart(idChart) {
      var _chart = this.blankSpace;
      for (var cChart in this.chartsList) {
        if (this.chartsList[cChart].id == idChart) {
          _chart = this.chartsList[cChart];
        }
      }
      return _chart;
    },

    isBlankSpace(chart) {
      return chart._Entity == null;
    },

    parseChartOptions(config) {
      var configParsed = JSON.parse(config);
      return configParsed.options;
    },

    async setField(chart, size) {
      try {
        return {
        id: chart.id,
        value: size,
        name: chart.name,
        criterias: chart.criterias,
        criteriaDenied: chart.criteriaDenied,
        dimensionsCriterias: chart.dimensionsCriterias,
        _Entity: chart._Entity,
        options: this.parseChartOptions(chart.config),
        data: {},
        type: chart.type,
        customEntity: chart.customEntity,
        };
      } catch(error) {
        console.error(error);
      }
    },

  },
  async created () {
    try{
      this.dCharts = await this.getCharts(JSON.parse(this.dashboard.sizeChartsConfig));
    }
    catch(error){
      console.error(error);
    }
  }
}
</script>
